// @ts-ignore
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { H1, Text, Spin, Link, useStaticUrls, useGeneratePath } from 'platform-components';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// @ts-ignore
import { IconArrowLeft } from 'common.components/icon2';
import PageContentTitle from 'common.components/page-content-title/page-content-title';
import { actions as coursesActions } from 'store/courses/actions';
import { getCoursesLoadingStatus } from 'store/courses/selectors';
import { getTeamIdFromPath } from 'utils/path';

import { ExamsResultsTable } from './__table/exams-results__table';

import './exams-results.scss';
import { b } from './cn';

export const ExamsResults = () => {
    const { labClassStudents, labClasses } = useStaticUrls();
    const dispatch = useDispatch();

    const classId = getTeamIdFromPath();

    const subjectsLoadingStatus = useSelector((storeState) => getCoursesLoadingStatus(storeState, { classId }));

    useEffect(() => {
        if (classId && subjectsLoadingStatus !== LOADING_STATUSES.SUCCESS) {
            dispatch(coursesActions.getCoursesByTeamRequest({ teamId: classId }));
        }
    }, [classId, subjectsLoadingStatus, dispatch]);

    const isLoading = subjectsLoadingStatus !== LOADING_STATUSES.SUCCESS;

    const genPath = useGeneratePath();
    const backLink = classId ? genPath(labClassStudents, { classId }) : genPath(labClasses);

    return (
        <div className={b()}>
            <Link isRouter to={backLink}>
                <IconArrowLeft /> <Text id="class.backToClass" />
            </Link>
            <PageContentTitle title={<H1 id="classes.examsResults.pageTitle" />} />

            {isLoading ? <Spin mix={b('spin')} size={Spin.SIZE.XL} /> : <ExamsResultsTable classId={classId} />}
        </div>
    );
};
